var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163.839,
    height: 163.839,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 4335 4335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2167.46,
    x2: 2167.46,
    y1: 868.38,
    y2: 3596.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D5B73E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C09410"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2167.46,
    x2: 2167.46,
    y1: 845.69,
    y2: 3573.9,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4267,
    height: 2728,
    x: 34,
    y: 868,
    fill: "url(#a)",
    rx: 262,
    ry: 262
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4267,
    height: 2728,
    x: 34,
    y: 846,
    fill: "url(#b)",
    rx: 262,
    ry: 262
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e41d2c",
    d: "m1172 2226 19-75c73-22 222-32 250 47 16 46-30 237-39 293l-71 1c-16-20-3 17-14-32-68 61-213 51-202-72 11-122 117-106 232-124-2-78-100-57-176-39zm535-12c-65 0-75-14-132 11 7 71 44 43 95 77 97 64-7 262-238 177l13-72c65 13 98 26 148-2 12-101-167-35-117-197 27-88 146-76 244-67l-14 73zm-996-153 153 5 16 240 83-192c28-69 9-54 185-52l-79 429-86-1 47-308-127 310-103-3c-3-60-8-271-24-311l-52 312-90-1 77-428zm1459 911 42-50c-84-11-99 13-137-55l193-2c12-20 32-39 42-62-220-15-282 41-317-55h353l39-61-436-2-20-51 470-2c27-15 27-32 34-63l-445-1c-80 1-85 19-100-54h560l18-62-164-2-8 42-94-4 59-349 89 12c0 2 2 9 2 12 0 2 1 5 1 6l5 18c25-30 41-52 99-50l-30 81c-17 22-67-3-88 57l98 4c11-63 23-82 41-133l1-30-613 1-2 22c33 0 32-6 51 10l-9 59c-62 15-60-22-66 59 9 15-2 7 17 12l39 1c63-205 251-160 294-96 23 34 46 146-11 155l-191 2c9 101 125 80 200 55-3 42 0 76-39 90-31 11-96 8-130 0-84-19-120-61-126-152l-36-1c-33-15-7 0-24-41-14 84-52 138 52 126-6 50 1 67-54 73-160 19-108-88-82-231 41-228 9-200 125-198l596 1-12-62-576-2 11-50 545-3c-14-85-17-64-215-64h-302c21-73 10-53 206-53h265l-28-63-384-1 26-52 321-2c-41-84-39-60-266-64 29-72 80-54 169-54-25-40-43-37-58-71-37-19-70-53-107-79-283-200-667-221-975-71-277 134-549 444-546 873 4 613 542 1060 1151 956 286-49 358-165 476-230z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8b02b",
    d: "M2823 2149c310-63 259 90 234 214-8 37-8 110-37 130-7 0-48 1-52-1-28-11-15 22-19-29-84 48-217 59-201-75 13-107 121-124 231-119-4-79-76-66-176-41l21-79zm306-9 83 1c1 2 2 5 2 7l13 37c15-23 43-43 87-44l-12 71-41 16c-82 27-77 130-99 265h-93l60-353zm441-76h85l-73 430c-95 1-72 6-102-30-62 92-248 7-191-183 42-142 184-180 254-96l28-122zm-1399-540c15 34 34 31 58 71-89 0-140-19-169 54 227 4 225-20 266 64l-321 2-26 52 384 1 28 63h-265c-195 0-185-19-206 53h302c198 0 201-21 215 64l-545 3-11 50 576 2 12 62-596-1-8 56 613-1-1 30c46-44 38-67 124-92 71-20 116-5 186 10l-15 92c-120-36-198-27-226 97-31 133 74 183 185 130-10 97-26 121-140 106-79-10-103-48-138-95h-143l-8 55 164 2-18 62h-560c15 73 20 55 100 54l445 1c-8 30-7 48-34 63l-470 2 20 51 436 2-39 61h-353c35 95 97 40 317 55-10 23-30 42-42 62l-193 2c37 67 53 44 137 55l-42 50c143 105 254 193 485 233 210 36 429-4 598-87 732-361 712-1401-6-1745-258-123-600-134-867 6-129 67-160 115-208 144z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "m634 2490 90 1 52-312c16 40 21 251 24 311l103 3 127-310-47 308 86 1 79-429c-176-2-157-17-185 52l-83 192-16-240-153-5-77 428zM3420 2412c-75-77-11-205 59-188 69 17 56 186-59 188zm122-227c-70-84-211-46-254 96-57 189 129 275 191 183 30 36 7 30 102 30l73-430h-85l-28 122zM2855 2412c-14-67 48-93 107-81 3 68-45 105-107 81zm-32-263-21 79c100-24 173-37 176 41-110-5-218 12-231 119-17 134 117 123 201 75 4 51-9 18 19 29 4 2 45 1 52 1 30-19 30-93 37-130 26-125 76-277-234-214zM1331 2328c2 34-4 60-26 77-15 11-60 24-78 7-56-51 49-85 103-84zm-159-102c76-18 174-39 176 39-115 18-221 2-232 124-12 123 133 133 202 72 11 49-2 12 14 32l71-1c9-57 55-247 39-293-28-80-176-70-250-47l-19 75zM2001 2276c13-51 35-72 94-64 21 30 21 21 25 64h-119zm-106 5-4 54c6 91 43 132 126 152 34 8 99 11 130 0 39-13 36-48 39-90-75 25-191 46-200-55l191-2c57-9 34-120 11-155-43-64-231-109-294 96zM2477 2148c-18 51-30 70-41 133v55l17 61c35 47 59 85 138 95 114 15 130-9 140-106-112 53-216 3-185-130 29-125 107-133 226-97l15-92c-70-14-115-29-186-10-86 24-78 48-124 92zM1720 2141c-98-8-217-21-244 67-50 162 128 96 117 197-51 28-83 15-148 2l-13 72c231 85 334-112 238-177-51-34-88-5-95-77 57-26 66-11 132-11l14-73z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "m1832 2293 7-24c6-81 4-44 66-59l9-59c-19-16-18-10-51-10l2-22 8-56c-116-2-84-30-125 198-26 143-78 250 82 231 54-6 48-23 54-73-103 12-65-42-52-126zM2302 2452l8-55 10-60 18-60c22-60 72-35 88-57l30-81c-59-2-75 20-99 50l-5-18c0-1-1-4-1-6s-2-10-2-12l-89-12-59 349 94 4 8-42zM3069 2493h93c22-135 17-238 99-265l41-16 12-71c-44 1-72 21-87 44l-13-37c-1-2-1-5-2-7l-83-1-60 353z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8b02b",
    d: "M3420 2412c116-2 129-171 59-188-71-17-134 111-59 188z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e41d2c",
    d: "M1331 2328c-54-1-159 33-103 84 18 16 63 3 78-7 22-16 27-43 26-77zM2310 2397h143l-17-61h-116z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8b02b",
    d: "M2855 2412c63 23 110-13 107-81-60-11-121 15-107 81zM2320 2336h116v-55l-98-5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e41d2c",
    d: "M2001 2276h119c-3-42-4-34-25-64-59-8-81 13-94 64z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8b02b",
    d: "M1832 2293c17 41-9 26 24 41l36 1 4-54-39-1c-20-4-9 3-17-12l-7 24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.b1268f425de6712ca375c54dbc466baf.svg";
export { ForwardRef as ReactComponent };